import { faCircleCheck } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import type { ProductPlan } from 'bundles/connect/types';
import React from 'react';
import { Badge, Card, Col, Row } from 'react-bootstrap-5';

type Props = {
  plan: ProductPlan;
}

export default function SelectedPlan({ plan }: Props) {
  const annual = plan.productKey.includes('Annual');
  const discounted = !!plan.discountedPrice;

  return (
    <Card className="h-lg-100 position-relative">
      <Card.Header>
        <Row>
          <Col>
            <Badge bg="" className="border rounded text-body muted mb-1">
              <FontAwesomeIcon className="text-secondary" icon={faCircleCheck} />
              <small>Selected Plan</small>
            </Badge>
            <h5 className="mb-1">
              <i className={`fa-regular me-3 fa-sm ${plan.icon}`}></i>
              {plan.title}
            </h5>
            <small className="text-muted">{plan.subtitle}</small>
          </Col>
        </Row>
      </Card.Header>
      <div className="d-md-block flex-grow-1">
        <Card.Body className="border-bottom h-100">
          <div className="d-flex flex-column gap-3">
            {plan.bullets.map((bullet, index) => (
              <div className="d-flex gap-3" key={index}>
                <div>
                  <i className={`fa-regular fa-fw text-accent ${bullet.icon}`}></i>
                </div>
                <div className="d-flex flex-column flex-grow-1">
                  {bullet.title}
                </div>
              </div>
            ))}
          </div>
        </Card.Body>
      </div>
      <Card.Footer className="border-0">
        <Row className="align-items-center gx-0">
          <Col>
            <div className="row gx-1 align-items-center">
              <Col className="text-muted fst-italic">Billed {annual ? 'Annually' : 'Monthly'}</Col>
              <Col className="d-flex position-relative justify-content-end">
                <h6 className={`mb-auto ${discounted ? 'pt-3' : ''}`}>$</h6>
                <div className="position-relative">
                  {discounted && (
                    <div className="position-absolute top-0 z-0">
                      <Badge className="py-0 px-1 muted shadow-sm">
                        <div className="d-flex text-muted-more">
                          <strong className="m-0 text-decoration-line-through">{plan.price}</strong>
                        </div>
                      </Badge>
                    </div>
                  )}
                  <div className={`d-flex position-relative z-1 ${discounted ? 'pt-3' : ''}`}>
                    <h2 className="m-0 text-gradient">{plan.discountedPrice || plan.price}</h2>
                    <h5 className="mt-5 mb-0">/mo</h5>
                  </div>
                </div>
              </Col>
            </div>
          </Col>
        </Row>
      </Card.Footer>
    </Card>
  );
}
